if (!customElements.get('trovik-order-summary')) {
  customElements.define('trovik-order-summary', class extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('script').textContent);
      this.info = this.closest('product-info');
      this.updateSummary = () => {
        const form = document.getElementById('product-form-' + this.dataset.section);
        const variant = this.variants.find(v => String(v.id) === form?.querySelector('[name="id"]')?.value) || this.variants[0];
        const count = Number(document.getElementById('Quantity-' + this.dataset.section)?.value) || 1;
        const values = { '[data-order-quantity]': String(count), '[data-order-total]': new Intl.NumberFormat('de-CH', {style:'currency', currency:this.dataset.currency || 'CHF'}).format(variant.price * count / 100), '[data-availability]': variant.available ? 'Bestellbar' : 'Zurzeit nicht verfügbar' };
        Object.entries(values).forEach(([selector, value]) => { const el=this.querySelector(selector); if(el && el.textContent!==value) el.textContent=value; });
      };
      this.info?.addEventListener('change', this.updateSummary);
      this.observer = new MutationObserver(this.updateSummary);
      if(this.info) this.observer.observe(this.info, {childList:true,subtree:true,attributes:true,attributeFilter:['value']});
      this.updateSummary();
    }
    disconnectedCallback() { this.info?.removeEventListener('change', this.updateSummary); this.observer?.disconnect(); }
  });
}

(()=>{
  if(!/\/products\/trovik-flex-v2\/?$/.test(location.pathname))return;
  if(document.documentElement.dataset.tvOriginalPriceReady)return;
  const scope=document.querySelector('[id^="ProductInfo-"]');
  if(!scope)return;
  document.documentElement.dataset.tvOriginalPriceReady='true';
  let productData,scheduled=false;
  const formatter=new Intl.NumberFormat('de-CH',{style:'currency',currency:window.Shopify?.currency?.active||'CHF',minimumFractionDigits:2,maximumFractionDigits:2});
  const apply=()=>{
    scheduled=false;
    if(!productData)return;
    const offer=scope.querySelector('.sw-offer');
    if(!offer||!/^1 Paar/.test(offer.querySelector('.sw-offer-title')?.textContent.trim()||''))return;
    const holder=offer.querySelector('.sw-price');
    if(!holder)return;
    const id=scope.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
    const variant=productData.variants.find(v=>String(v.id)===String(id))||productData.variants[0];
    let compare=holder.querySelector('.sw-price-compare');
    if(compare&&!compare.hasAttribute('data-tv-original-price'))return;
    if(!variant||!(variant.compare_at_price>variant.price)){compare?.remove();return;}
    if(!compare){
      compare=document.createElement('s');
      compare.className='sw-price-compare';
      compare.setAttribute('data-tv-original-price','');
      holder.append(compare);
    }
    const value=formatter.format(variant.compare_at_price/100);
    if(compare.textContent!==value)compare.textContent=value;
  };
  const schedule=()=>{if(!scheduled){scheduled=true;requestAnimationFrame(apply);}};
  const observer=new MutationObserver(schedule);
  observer.observe(scope,{childList:true,subtree:true});
  scope.addEventListener('change',schedule);
  window.addEventListener('pagehide',()=>observer.disconnect(),{once:true});
  fetch((window.Shopify?.routes?.root||'/')+'products/trovik-flex-v2.js',{credentials:'same-origin'})
    .then(r=>r.ok?r.json():Promise.reject(new Error('Product data unavailable')))
    .then(data=>{productData=data;schedule();}).catch(()=>{});
})();
